import React, { forwardRef, useImperativeHandle, useState } from 'react'
import { Modal } from 'react-bootstrap'

export interface ImagePreviewRef {
    open: (link: string) => void
    close: () => void
}

interface ImagePreviewProp { }

const ImagePreview = forwardRef<ImagePreviewRef, ImagePreviewProp>(({ }, ref) => {

    const [showImageModal, setShowImageModal] = useState(false)
    const [imageLink, setImageLink] = useState<string>('')

    useImperativeHandle(ref, () => ({
        open: (link: string) => {
            setImageLink(link)
            setShowImageModal(true)
        },
        close: () => {
            handleClose()
        }
    }))

    const handleClose = () => {
        setShowImageModal(false)
        setImageLink('')
    }

    if (!imageLink?.trim()) return null

    return (
        <>
            <Modal show={showImageModal} onHide={handleClose} centered size="lg">
                <Modal.Header closeButton className=" text-white border-0">
                    <Modal.Title className="fs-5">Image Preview</Modal.Title>
                </Modal.Header>

                <Modal.Body className="bg-light d-flex flex-column align-items-center justify-content-center p-4">
                    <div
                        className="border rounded shadow-lg overflow-hidden"
                        style={{ maxHeight: "500px", maxWidth: "100%", borderColor: "#dee2e6" }}
                    >
                        <img
                            src={imageLink ?? ""}
                            alt="Preview"
                            className="img-fluid"
                            style={{ objectFit: "contain", height: "100%", width: "100%" }}
                        />
                    </div>
                </Modal.Body>

                <Modal.Footer className="bg-white border-0 d-flex justify-content-between">
                </Modal.Footer>
            </Modal>
        </>
    )
})

export default ImagePreview